const remove = ({ data, oldData, draft }) => {
  const result = { ...oldData };

  if (!!draft?.items && Array.isArray(oldData?.items)) {
    result.items = oldData.items.filter(
      (item: any) => String(item?.id) !== String(data?.id),
    );
  }

  if (!!draft?.data && Array.isArray(oldData?.data)) {
    result.data = oldData.data.filter(
      (item: any) => String(item?.id) !== String(data?.id),
    );
  }

  return result;
};

export default remove;
